import PortalIdParser from 'PortalIdParser';
export const getVariantGenerationChannelName = strategyId => `personalize:${PortalIdParser.get()}:variant_generation_events:${strategyId}`;